import Green1 from "../assets/ProductImages/green1.jpeg";
import Green2 from "../assets/ProductImages/green2.jpeg";
import Green5 from "../assets/ProductImages/green5.jpeg";
import Black1 from "../assets/ProductImages/black1.jpeg";
import Black2 from "../assets/ProductImages/black5.jpeg";
import Black3 from "../assets/ProductImages/black7.jpeg";
import Black4   from "../assets/ProductImages/tee5.jpg";
import Champagne from "../assets/ProductImages/champagne.jpg";
import varsity from "../assets/ProductImages/versity4.jpg";
import HarryPotter from "../assets/ProductImages/harrypoter.jpg";
import Shirt1 from "../assets/ProductImages/shirt1.jpg";
import Jeans1 from "../assets/ProductImages/jeans.jpg";
import acc1 from "../assets/ProductImages/acc1.jpg";
import tee1 from "../assets/ProductImages/tee5.jpg"
import Bracelet from "../assets/ProductImages/acc1.jpg";
import Bracelet2 from "../assets/ProductImages/acc4.jpg";
import Jeans2 from "../assets/ProductImages/jeans.jpg";
import Shirt2 from "../assets/ProductImages/shirt16.jpg";
import NewArrivals from "../components/NewArrivals.js";

const latestDrops = [
  {
    id:1,
    title: "Bambiha: The Degenerate",
    category: "Oversized T-Shirts",
    price: "850",
    img: Black1,
  },
  {
    id:2,
    title: "Oversized Shirt: Green",
    category: "Oversized T-Shirts",
    price: "1299",
    img: Green5,
  },
  {
    id:3,
    title: "Varsity T-Shirt: Sangria",
    category: "Oversized T-Shirts",
    price: "1299",
    img: Black3,
  },
  {
    id:4,
    title: "Chaos: The Anarchist",
    category: "Oversized T-Shirts",
    price: "1699",
    img: Black4,
  },

  {
    id:5,
    title: "Bracelet: Men Modern Design",
    category: "Accessories",
    price: "349",
    img: Bracelet,
  },
        {
            id:6,
            title: "Men: Modern Neck chain",
            category: "Accessories",
            price: "349",
            img: Bracelet2,
        },

          {
            id:7,
    title: "Men: Straight Denim Jeans",
    category: "Bottoms",
    price: "1199",
    img: Jeans2,
  },

            {
                id:8,
    title: "Men: Blue Checked Shirt",
    category: "shirts",
    price: "899",
    img: Shirt2,
  },
];


export default latestDrops